class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.backdrop = document.getElementById('DrawerBackdrop');
    if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });

    // Clicks inside the drawer: close, quantity stepper
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-close-drawer]')) { this.close(); return; }
      const colour = e.target.closest('[data-addon-variant]');
      if (colour) {
        const card = colour.closest('[data-addon-card]');
        card.querySelectorAll('[data-addon-variant]').forEach((b) => { const on = b === colour; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
        const add = card.querySelector('[data-quick-add-id]');
        if (add) add.dataset.quickAddId = colour.dataset.addonVariant;
        const img = card.querySelector('[data-addon-img]');
        if (img && colour.dataset.image) img.src = colour.dataset.image;
        const price = card.querySelector('[data-addon-price]');
        if (price && colour.dataset.price) price.textContent = colour.dataset.price;
        return;
      }
      const stepper = e.target.closest('[data-qty-change]');
      if (stepper) {
        const key = stepper.dataset.key;
        const currentQty = parseInt(stepper.dataset.currentQty, 10);
        const delta = parseInt(stepper.dataset.qtyChange, 10);
        this.updateItem(key, Math.max(0, currentQty + delta));
      }
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('#CartDrawerNote')) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        });
      }
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (this.backdrop) this.backdrop.classList.add('is-active');
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.backdrop) this.backdrop.classList.remove('is-active');
  }

  async refresh() {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const fresh = doc.querySelector('cart-drawer');
    if (fresh) this.innerHTML = fresh.innerHTML;

    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  }

  async addItem(id, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity, properties }] })
      });
      if (res.ok) {
        await this.refresh();
        this.open();
        return true;
      } else {
        const err = await res.json();
        alert(err.description || 'Sorry, that item could not be added.');
      }
    } catch (err) {
      console.error('Failed to add item to bag', err);
    }
    return false;
  }

  async updateItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      await this.refresh();
    } catch (err) {
      console.error('Failed to change item quantity', err);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

window.openCartDrawer = () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) drawer.open();
};

// Personalised totes (Zepto Product Personalizer): the app adds the bag and the personalisation line itself, then
// sends the shopper to the full /cart page unless the theme defines this hook (Ali, 3 Nov). Close the app's pop-up,
// refresh the side cart, open it, and let the app tidy its own rows in it.
window.pplr_update_minicart = async () => {
  try { if (typeof window.pplr_w_h === 'function') window.pplr_w_h(); } catch (_) {}
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) { window.location.href = '/cart'; return; }
  await drawer.refresh();
  drawer.open();
  try { if (typeof window.pplr_cart_item_config === 'function') window.pplr_cart_item_config(true); } catch (_) {}
  // The app prices its personalisation line just after this hook runs, so the first total can be stale: refresh once more
  setTimeout(async () => {
    await drawer.refresh();
    try { if (typeof window.pplr_cart_item_config === 'function') window.pplr_cart_item_config(true); } catch (_) {}
  }, 1500);
};

// One-tap "quick add" buttons anywhere on the page (product cards, colour rail, cart add-ons).
// The button shows the same inverted "adding" state as the main Add to bag button while the request runs.
document.addEventListener('click', async (e) => {
  const quickAdd = e.target.closest('[data-quick-add-id]');
  if (!quickAdd || quickAdd.disabled || quickAdd.getAttribute('aria-busy') === 'true') return;
  e.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  quickAdd.classList.add('is-adding');
  quickAdd.setAttribute('aria-busy', 'true');
  await drawer.addItem(quickAdd.dataset.quickAddId, 1);
  quickAdd.classList.remove('is-adding');
  quickAdd.removeAttribute('aria-busy');
});
